var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 5.95015V11.9599C13 12.2358 12.8858 12.5003 12.6827 12.6954C12.4795 12.8904 12.204 13 11.9167 13H9.20832C8.92101 13 8.64546 12.8904 8.44229 12.6954C8.23913 12.5003 8.12499 12.2358 8.12499 11.9599V9.35969C8.12499 9.22177 8.06792 9.08949 7.96634 8.99196C7.86476 8.89444 7.72698 8.83965 7.58332 8.83965H5.41666C5.273 8.83965 5.13523 8.89444 5.03364 8.99196C4.93206 9.08949 4.87499 9.22177 4.87499 9.35969V11.9599C4.87499 12.2358 4.76086 12.5003 4.55769 12.6954C4.35453 12.8904 4.07898 13 3.79166 13H1.08333C0.796015 13 0.520465 12.8904 0.317301 12.6954C0.114136 12.5003 1.25178e-08 12.2358 1.25178e-08 11.9599V5.95015C-2.2779e-05 5.8062 0.0310776 5.66382 0.0913327 5.532C0.151588 5.40019 0.239686 5.28182 0.350052 5.18439L5.76671 0.277768L5.77416 0.270618C5.97359 0.0964893 6.23347 0 6.50304 0C6.77261 0 7.03249 0.0964893 7.23192 0.270618C7.23423 0.273161 7.23672 0.27555 7.23937 0.277768L12.656 5.18439C12.7653 5.28234 12.8522 5.40094 12.9114 5.53272C12.9706 5.66451 13.0008 5.80663 13 5.95015Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/organisation.fbb12cef238ac1ca4756aeeb0adec94b.svg";
export { ForwardRef as ReactComponent };